import React from 'react'
import './HomePage.scss'
import { Grid, Card, Icon, Button, Segment } from 'semantic-ui-react'

export default function HomePage() {

    return (
        <div className='page-content'>
            <Segment basic verticalalign='middle' className='subcontent py-0 mt-3'>
                <Grid textAlign='center' style={{ height: '80vh' }} verticalAlign='middle'>
                    <Grid.Row textAlign='center' columns={4} style={{ margin: 0 }}>
                        <Grid.Column>
                            <Card style={{ borderRadius: 0, width: '100%' }}>
                                <Card.Content header='Relatórios' />
                                <Card.Content description={<Icon name='file alternate outline' size='huge' />} />
                                <Card.Content extra>
                                    <Button className='editButtonIr' size='tiny' icon labelPosition='right' primary>
                                        <Icon name='arrow right' />
                                        IR
                                </Button>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card style={{ borderRadius: 0, width: '100%' }}>
                                <Card.Content header='Menu 2' />
                                <Card.Content description={<Icon name='file alternate outline' size='huge' />} />
                                <Card.Content extra>
                                    <Button className='editButtonIr' size='tiny' icon labelPosition='right' primary>
                                        <Icon name='arrow right' />
                                        IR
                                </Button>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column className='blocoHome'>
                            <Card style={{ borderRadius: 0, width: '100%' }}>
                                <Card.Content header='Menu 3' />
                                <Card.Content description={<Icon name='file alternate outline' size='huge' />} />
                                <Card.Content extra>
                                    <Button className='editButtonIr' size='tiny' icon labelPosition='right' primary>
                                        <Icon name='arrow right' />
                                        IR
                                </Button>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column>
                            <Card style={{ borderRadius: 0, width: '100%' }}>
                                <Card.Content header='Menu 4' />
                                <Card.Content description={<Icon name='file alternate outline' size='huge' />} />
                                <Card.Content extra>
                                    <Button className='editButtonIr' size='tiny' icon labelPosition='right' primary>
                                        <Icon name='arrow right' />
                                        IR
                                </Button>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        </div>
    )
}
